
import teamApi from '@/api/team';

const SET_ALL = 'SET_ALL';
const RESET_ALL = 'RESET_ALL';
const APPEND_ALL = 'APPEND_ALL';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const DELETE = 'DELETE';
const SET_SCHEDULE = 'SET_SCHEDULE';
const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
const UPDATE_STATUS = 'UPDATE_STATUS';
const SET_IS_FETCHING_SCHEDULE = 'SET_IS_FETCHING_SCHEDULE';

const defaultParams = {
	limit: 1000,
	sort_by: 'name',
	sort: 'asc',
	page: 1,
	include_owner: true,
};

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	schedule: null,
	isFetchingSchedule: false,
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	schedule: state => state.schedule,
	isFetchingSchedule: state => state.isFetchingSchedule,
};

const mutations = {
	[SET_ALL](state, members) {
		state.all = members;
	},
	[APPEND_ALL](state, members) {
		// state.all = state.all.concat(members);
		for (let index = 0; index < members.length; index++) {
			const member = members[index];
			const memberId = member._id;
			// Check if member exist
			const memberIndex = state.all.findIndex(({ _id }) => _id === memberId);
			if (memberIndex === -1) {
				state.all.push(member);
			}
		}
	},
	[RESET_ALL](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[DELETE](state, index) {
		state.all.splice(index, 1);
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_SCHEDULE](state, value) {
		state.schedule = value;
	},
	[UPDATE_SCHEDULE](state, data) {
		const key = data.key;
		const value = data.value;
		const type = data.type;
		if (type === 'status') {
			state.schedule[key].enabled = value;
		} else if (type === 'start') {
			state.schedule[key].start = parseInt(value);
		} else if (type === 'end') {
			state.schedule[key].end = parseInt(value);
		}
	},
	[SET_IS_FETCHING_SCHEDULE](state, value) {
		state.isFetchingSchedule = value;
	},
	[UPDATE_STATUS](state, member) {
		const memberIndex = state.all.findIndex(curr => curr._id === member._id);
		if (memberIndex !== -1) {
			state.all[memberIndex].is_active = member.is_active;
		}
	},
};

const actions = {
	fetch({ commit, getters }, params) {
		if (!params) params = defaultParams;
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const members = response.data;
				if (members.length !== 0) {
					commit(APPEND_ALL, members);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			teamApi.getMembers(params, callback, errorCallback);
		}
	},
	reset({ commit }) {
		commit(RESET_ALL);
	},
	delete({ commit }, index) {
		commit(DELETE, index);
	},
	fetchSchedule({ commit }, id) {
		commit(SET_IS_FETCHING_SCHEDULE, true);
		const callback = (response) => {
			const members = response.data;
			const schedule = members.schedule;
			commit(SET_SCHEDULE, schedule);
			commit(SET_IS_FETCHING_SCHEDULE, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING_SCHEDULE, true);
		};
		teamApi.getSchedule(id, callback, errorCallback);
	},
	updateSchedule({ commit }, data) {
		commit(UPDATE_SCHEDULE, data);
	},
	updateStatus({ commit }, member) {
		commit(UPDATE_STATUS, member);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
